import { render } from "./EditorCopyPagelists.vue?vue&type=template&id=0026e010"
import script from "./EditorCopyPagelists.vue?vue&type=script&lang=js"
export * from "./EditorCopyPagelists.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__